import { useLazyQuery } from '@apollo/client';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { GET_STRIPE_CONFIG } from '~/data/cart';
import { ContentElementStrip } from './ContentElementStrip';
import useClient from '~/hooks/useClient';

const ConnectStripe = ({ onChangeElementStripe }: any) => {
    const isClient = useClient();
    const [getStripeConfig, { data, loading }] = useLazyQuery(GET_STRIPE_CONFIG, {
        fetchPolicy: 'network-only',
        onError: ({ message }) => toast.error(message)
    });

    useEffect(() => {
        getStripeConfig();
    }, []);

    let stripeConfigId;
    let stripePromise = null;

    const storeConfig = data?.storeConfig;
    if (storeConfig?.stripe_mode === 'test') {
        stripePromise = loadStripe(storeConfig?.stripe_test_pk);
        stripeConfigId = storeConfig?.stripe_test_pk;
    } else if (storeConfig?.stripe_mode === 'live') {
        stripePromise = loadStripe(storeConfig.stripe_live_pk);
        stripeConfigId = storeConfig.stripe_live_pk;
    }

    if (!isClient) return null;
    if (!stripeConfigId || !stripeConfigId.length || loading) {
        return <div className="w-full">loading stripe...</div>;
    }

    const onChange = (event: any) => {
        onChangeElementStripe(event);
    };

    return (
        <Elements stripe={stripePromise as any} options={{}}>
            <ContentElementStrip onChange={onChange} />
        </Elements>
    );
};

export default ConnectStripe;
